export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-lightbox/index.js